import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  getCompanyUsersList,
  getCompanyUsersLoading,
  getLastDivisionSet,
} from '../UserManagement/store/UserManagementSelectors'
import {
  companyDivisionsSelector,
  managedCompaniesSelector,
  userCompaniesSelector,
} from '../Settings/store/SettingsSelectors'
import TeamManagement, { ITeamManagementDispatchProps } from './TeamManagement'
import {
  deleteTeams,
  getCompanyTeams,
  //getDivisionsDeprecated as getDivisionsAction,
  lockTeams,
  renameTeam,
  setSelectedGroupId,
  setSelectedGroupIdForCompany,
  unlockTeams,
  assignTeamsRandomly,
  generateTeams,
  getDivisionCategories,
  createDivisionCategory,
  deleteDivisionCategory,
} from './store/TeamManagementActions'
import { clearNotification } from '../../../src/common/notifications/NotificationActions'
import {
  getCreatedDivisionId,
  getDeletedDivisionIds,
  getLastTeamsUpdate,
  getLastUpdatedTeamSettings,
  getTeamsList,
  getTeamsLoading,
  getRenameTeamFailed,
  getDivisionCategories as getDivisionCategoriesSelector,
  getGroupsLoading,
  getSelectedGroupId,
  getSelectedGroupIdPerCompany,
  //getDivisionsSelectorDeprecated,
} from './store/TeamManagementSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'
import { getCompanyUsers } from '../UserManagement/store/UserManagementActions'
import { getCompanyDivisions, setDivisionsLoading } from '../Settings/store/SettingsActions'

const mapStateToProps = (state: IGlobalState) => ({
  //companyTeams: getTeamsList(state),
  teamsLoading: getTeamsLoading(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
  createdDivisionId: getCreatedDivisionId(state),
  deletedDivisionIds: getDeletedDivisionIds(state),
  lastTeamsUpdate: getLastTeamsUpdate(state),
  lastDivisionSet: getLastDivisionSet(state),
  lastUpdatedTeamSettings: getLastUpdatedTeamSettings(state),
  managedCompanies: managedCompaniesSelector(state),
  userCompanies: userCompaniesSelector(state),
  companyUsers: getCompanyUsersList(state),
  usersLoading: getCompanyUsersLoading(state),
  renameTeamFailed: getRenameTeamFailed(state),
  divisionCategories: getDivisionCategoriesSelector(state),
  groupsLoading: getGroupsLoading(state),
  selectedGroupId: getSelectedGroupId(state),
  selectedGroupIdPerCompany: getSelectedGroupIdPerCompany(state),
  //companyGroups: getDivisionsSelectorDeprecated(state),
  divisions: companyDivisionsSelector(state),
})

const mapDispatchToProps: ITeamManagementDispatchProps = {
  //getCompanyTeams,
  getDivisions: getCompanyDivisions,
  renameTeam,
  deleteTeams,
  lockTeams,
  unlockTeams,
  setSelectedCompanyId: setCompanyAdminSelectedCompanyId,
  setSelectedGroupId,
  setSelectedGroupIdForCompany,
  assignTeamsRandomly,
  generateTeams,
  getCompanyUsers,
  getDivisionCategories,
  createDivisionCategory,
  deleteDivisionCategory,
  clearNotification,
  setDivisionsLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamManagement)
